import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const AppShell = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6 scrollbar-hide">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppShell;